import { ParsedDate } from '../parsed/parsedDate';
import { z } from 'zod';

export const OutdoorLocation = z.object({
    timestamp: ParsedDate.nullish(),
    lat: z.number().nullish(),
    lon: z.number().nullish(),
    status: z.string().nullish(),
    geofence: z
        .object({
            name: z.string().nullish(),
            north: z.number().nullish(),
            south: z.number().nullish(),
            east: z.number().nullish(),
            west: z.number().nullish(),
        })
        .nullish(),
});

export const IndoorLocation = z.object({
    ts: ParsedDate.nullish(),
    x: z.number().nullish(),
    y: z.number().nullish(),
    systemId: z.number().nullish(),
});

export const OverviewCart = z.object({
    cartGuid: z.string(),
    cartId: z.string(),
    storeGuid: z.string(),
    maintenanceLocation: z.string().nullish(),
    maintenanceNote: z.string().nullish(),
    isDisabled: z.boolean().nullish(),
    isMissing: z.boolean().nullish(),
    maintenanceMode: z.number().nullish(),
    desiredEnvironment: z.string().nullish(),
    lastBatteryCharge: z.number().nullish(),
    lastBatteryChargeOn: z.string().nullish(),
    lastBatteryChargingState1: z.string().nullish(),
    lastBatteryChargingState2: z.string().nullish(),
    location: z.string().nullish(),
    isGpsDisabled: z.boolean().nullish(),
    cartTicket: z.any().nullish(),
    hardwareRevision: z.string().nullish(),
    framenumber: z.string().nullish(),
    lastSeen: z.string().nullish(),
    isChargerConnected: z.boolean().nullish(),
    batteryLevel: z.string().nullish(),
    indoorLocation: IndoorLocation.nullish(),
    outdoorLocation: OutdoorLocation.nullish(),
});

export type OutdoorLocation = z.infer<typeof OutdoorLocation>;
export type IndoorLocation = z.infer<typeof IndoorLocation>;
export type OverviewCart = z.infer<typeof OverviewCart>;
